import { ChatbotService, FilesService, type StudioMedia, type StudioProject } from '../client'
import type { Editor } from './editorBridge'
import { fileName, mediaBytes } from './videoAd'

export async function loadProject(brandId: number, threadId: string): Promise<StudioProject | null> {
  try {
    return await ChatbotService.getStudioProject(threadId, brandId)
  } catch {
    return null
  }
}

export async function restoreProject(editor: Editor, brandId: number, project: StudioProject) {
  const files = await Promise.all(
    (project.media ?? []).map(async ({ path, url }) => ({ name: fileName(path), ...(await mediaBytes(brandId, url)) })),
  )
  await editor.call(
    'adlovin:restore',
    { project: project.project, files },
    files.map((file) => file.bytes),
  )
}

type Snapshot = { changed: boolean; project?: string; added?: { path: string; bytes: ArrayBuffer }[] }

export async function saveIfChanged(editor: Editor, brandId: number, threadId: string, media: Map<string, string>) {
  const snapshot = (await editor.call('adlovin:snapshot')) as Snapshot
  if (!snapshot.changed || !snapshot.project) return false
  for (const { path, bytes } of snapshot.added ?? []) {
    const saved = await FilesService.uploadFile(brandId, { file: new File([bytes], fileName(path)) })
    media.set(path, saved.url.split('?')[0])
  }
  const used: StudioMedia[] = [...media].map(([path, url]) => ({ path, url }))
  await ChatbotService.saveStudioProject(threadId, brandId, { project: snapshot.project, media: used })
  return true
}
